import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Oracle from "@/pages/Oracle";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Arcanes from "@/pages/Arcanes";
import Arcane from "@/pages/Arcane";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App min-h-screen">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tirage" element={<Oracle />} />
            <Route path="/observatoire" element={<Blog />} />
            <Route path="/observatoire/:slug" element={<BlogPost />} />
            <Route path="/arcanes" element={<Arcanes />} />
            <Route path="/arcanes/:slug" element={<Arcane />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
